// Today / AE experience rollout gate (GH#4247).
//
// ui_persona='ae' is a per-member setting (Workspace Members > Experience).
// When enabled, members see the AE Today dashboard and AE nav labels. Like the
// SDR gate, production honors the setting for every workspace — no vendor or
// pilot allowlist. (/tasks is the same hub for every persona since the AE
// Actions hub was retired, mb-server#6639.)
//
// Single source of truth: DashboardMain.tsx and the ProtectedLayout Menu must
// both call isAeExperienceRolledOut — never duplicate gating.
// AE is a sibling of the SDR experience, never a variant of it: do not gate
// AE surfaces on isSdr, and never overload isSdr to mean "any rep".
//
// This gate answers one question only: does the *signed-in* member get the AE
// experience? It deliberately knows nothing about view-as. A `?viewAs=<uuid>`
// link names who is being viewed, never what they are; resolving that target
// and choosing its experience belongs to `useViewAsTarget` /
// `constants/repExperience.ts`. Folding view-as into this gate is what routed a
// super admin opening an SDR's Today to the AE dashboard (mb-frontend#4573).

export { VIEW_AS_QUERY_PARAM as AE_VIEW_AS_QUERY_PARAM } from './repExperience';

export function isAeExperienceRolledOut(
  isAe: boolean | undefined,
  _vendorid?: number,
  _userId?: string | null,
): boolean {
  return isAe === true;
}
